
var variantId = $('.product-variants-innerpanel .variant-selector').val();
$('#case-number option').each(function(){
  var current = $(this);
  if($(this).attr('data-id') == variantId){
      setTimeout(function() { current.attr('data-sprice', $('.subscription-radio .price-label').text());},1500);
    }
  });

 setTimeout(function() { 
   $('.bundle-cart #mobile-cart-main .subscription-radio .discount-label').text($('.bundle-cart #mobile-cart-main .subscription-radio .discount-label').text().split('.')[0]+'%');
  $('.main-product-grid .subscription-radio .discount-label').text($('.main-product-grid .subscription-radio .discount-label').text().split('.')[0]+'%');
 },1500);



 $('.quick-view-trigger').click(function(){
   
   //$('#loader').removeClass('hidden');
    var varId = $(this).closest(".grid-item").attr('data-variant-id');
   var dataId = $(this).attr('data-id');
   var current = $(this);
   
  setTimeout(function() { 
    $('#case-number-quick option').attr('data-sprice', $('.rc-option__subsave .rc_widget__price--subsave').text());
    if(varId === dataId){
     $('#main-product-quick_add .case-cta .info .quantity').text(current.attr('data-pouches'));
      $('.rc-option__subsave .rc-option__text').text($('.rc-option__subsave .rc-option__text').text()+' '+$('.rc_widget__option__discount').text().split('.')[0]+'%');
      $('.rc_widget__option__discount').text('');
   }
   // $('#loader').addClass('hidden');
   
  },2000);


   
  });

$('.quick-view-trigger-mobile').click(function(){
   
    var varId = $(this).closest(".grid-item").attr('data-variant-id');
   var dataId = $(this).attr('data-id');
   var current = $(this);
   //alert(varId);
  setTimeout(function() { 
   
    $('#case-number-quick option').attr('data-sprice', $('.rc-option__subsave .rc_widget__price--subsave').text());
    if(varId === dataId){
     $('#main-product-quick_add .case-cta .info .quantity').text(current.attr('data-pouches'));
      $('.rc-option__subsave .rc-option__text').text($('.rc-option__subsave .rc-option__text').text()+' '+$('.rc_widget__option__discount').text().split('.')[0]+'%');
      $('.rc_widget__option__discount').text('');
   }
   
  },2000);
  });

$(document).on('change','#case_quantity',function(){ 
 //console.log("y");
  var num=$(this).val();
  var variantId = $('.product-variants-innerpanel .variant-selector').val();
if(variantId){
  $('#case-number option').each(function(){
        if($(this).attr('data-id') == variantId){
            var variantPrice = $(this).attr('data-price').split('$')[1];
            var subsPrice = $(this).attr('data-sprice').split('$')[1];
          $('.case-cta .info .quantity').text($(this).val()*num);
          $('.subscription-radio .price-label').text('$'+(subsPrice*num).toFixed(2));
          $('.onetime-radio .price-label').text('$'+(variantPrice*num).toFixed(2));
        }
  });

} else {
 
    var variantId = $('#main-product-quick_add product-variants input').val();

    $('#case-number-quick option').each(function(){
          if($(this).attr('data-id') == variantId){

              var variantPrice = $(this).attr('data-price').split('$')[1];
              var subsPrice = $(this).attr('data-sprice').split('$')[1];
            $('#main-product-quick_add .case-cta .info .quantity').text($(this).val()*num);
            $('#main-product-quick_add .rc-option__subsave .rc_widget__price--subsave').text('$'+(subsPrice*num).toFixed(2));
            $('#main-product-quick_add .rc-option__onetime .rc_widget__price--onetime').text('$'+(variantPrice*num).toFixed(2));
          }
    });
 

}
});

$(document).on('click','.rc-radio', function(){
 
  $('#case_quantity option:eq(0)').prop('selected', 'selected');
   $('#case-number-quick option').each(function(){
     
          if($(this).attr('data-id') === $('#main-product-quick_add product-variants input').val()){
              $('#main-product-quick_add .case-cta .info .quantity').text($(this).val());
               }
          });
  $('#case-number option').each(function(){
          if($(this).attr('data-id') === $('.main-product-grid product-variants .variant-selector').val()){
              $('.main-product-grid .case-cta .info .quantity').text($(this).val());
            $('.main-product-grid .subscription-radio .price-label').text($(this).attr('data-sprice'));
           $('.main-product-grid .onetime-radio .price-label').text($(this).attr('data-price'));
               }
          });
  
});




// $(document).ready(function(){
//  setTimeout(function() { 
//    $('.subscription-radio .price-label').text('$'+ Math.round($('.subscription-radio .price-label').text().split('$')[1]));
//    $('.onetime-radio .price-label').text('$'+ Math.round($('.onetime-radio .price-label').text().split('$')[1]));
//  },2500);
// })




 
  

